import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { autoHeightAnimate } from './utils';
import { InvoiceModal } from './invoice-modal';
export default function productPage() {
  if (!document.body.classList.contains('single-product')) return;
  addReadMoreBtnIfNeeded();
  addEventListenerToProductDetails();
  addEventListenerToProductAddons();
  addEventListenerToShowVideoBtns();
  removeScrollToGalleryButtonIfNeeded();
  addEventListenersToScrollBtns();
  addEventListenerToInvoiceBtn();
  moveVariationPriceIfSingleVariationInterval();
  addListenerToNoPriceBtn();
  initSlicksliderForLiveImages();
  setTimeout(function () {
    // extra koll ifall vi missat eventet
    createSliderForThumbnails();
  }, 1000);
  if ($('.ast-article-single').length && !$('.woocommerce-breadcrumb').is(':visible')) {
    $('.woocommerce-breadcrumb').detach().prependTo('.ast-woocommerce-container');
  }
  // if (window.location.pathname.indexOf('/produkt-kategori/begagnat') > -1 && window.location.search.indexOf('v=') == -1) {
  //   const randomNumber = Math.floor(10000 + Math.random() * 90000);
  //   window.location.href = window.location.href + 'v=' + randomNumber;
  // }
}

var PRODUCT_DESCRIPTION_TEXT_MAX_HEIGHT = 200;
var PRODUCT_DESCRIPTION_CONTAINER_HEIGHT = '150px';
var gallerySliderIsInitiated = false;

// När woocommerce har kört sitt javascript och skapat upp egna slick-sliders skickar den ut detta event.
// Detta får inte läggas i egen metod, då missar det eventloopen
$('#wl-product-gallery.woocommerce-product-gallery').on('wc-product-gallery-after-init', function () {
  createSliderForThumbnails();
});

/**
 * Det läggs ut en knapp på produktsidan om produkten inte har ett pris, tryck på denna triggar bara klick på vanliga offertknappen
 */
function addListenerToNoPriceBtn() {
  if (!document.getElementById('no-price-invoice-btn')) return;
  document.getElementById('no-price-invoice-btn').addEventListener('click', function () {
    document.getElementById('request-invoice-btn').click();
  });
}

/**
 * Om det bara finns en variant så kommer inte strukturen se likadan ut som om om det finns flera.
 * Till på köpet så renderas även strukturen om vid varje val som görs så vi lägger ut priset i en loop
 * så det visas vid val av variant precis som vanligt.
 */
function moveVariationPriceIfSingleVariationInterval() {
  setInterval(function () {
    var wcVariationPriceContainer = document.querySelector('.variations_form.cart .woocommerce-variation-price');
    var variationOptions = document.querySelectorAll('table.variations select option');
    var wlProductPrice = document.querySelector('.wl-product__container > .price');

    // Option ska ha två val för att detta ska köra.
    if (variationOptions.length !== 2 || !wlProductPrice || !wcVariationPriceContainer || wcVariationPriceContainer.classList.contains('wl-element-added')) return;
    var priceClone = wlProductPrice.cloneNode(true);
    wcVariationPriceContainer.classList.add('wl-element-added');
    wcVariationPriceContainer.appendChild(priceClone);
  }, 300);
}
function removeScrollToGalleryButtonIfNeeded() {
  if (!document.getElementById('wl-product-video') && document.getElementById('scroll-to-video-button')) document.getElementById('scroll-to-video-button').remove();
}
function addReadMoreBtnIfNeeded() {
  var descriptionContainer = document.querySelector('.wl-product-description__container');
  if (descriptionContainer && descriptionContainer.scrollHeight > PRODUCT_DESCRIPTION_TEXT_MAX_HEIGHT) {
    var readMoreBtnContainer = document.createElement('div');
    var hideTextElement = document.createElement('div');
    hideTextElement.classList.add('wl-hide-text');
    readMoreBtnContainer.classList.add('wl-read-more-btn__container');
    readMoreBtnContainer.innerHTML = "<button id=\"wl-read-more-btn\" class=\"wl-button\">\n                                        L\xE4s mer\n                                      </button>";
    descriptionContainer.style.height = PRODUCT_DESCRIPTION_CONTAINER_HEIGHT;
    descriptionContainer.append(hideTextElement);
    descriptionContainer.parentElement.append(readMoreBtnContainer);
    addReadMoreBtnClickEvent(descriptionContainer, hideTextElement);
  }
}
function addReadMoreBtnClickEvent(descriptionContainer, hideTextElement) {
  document.getElementById('wl-read-more-btn').addEventListener('click', function () {
    if (!hideTextElement.classList.contains('-is-hidden')) {
      autoHeightAnimate($(descriptionContainer), 150);
      document.getElementById('wl-read-more-btn').textContent = 'Visa mindre';
    } else {
      descriptionContainer.style.height = PRODUCT_DESCRIPTION_CONTAINER_HEIGHT;
      document.getElementById('wl-read-more-btn').textContent = 'Läs mer';
    }
    hideTextElement.classList.toggle('-is-hidden');
  });
}
function addEventListenerToProductDetails() {
  if (!document.querySelector('.product-details__container')) return;
  $('.product-details__container').on('click', function (e) {
    $(e.target).parent().toggleClass('-is-open');
    $('.product-detail__content', $(e.target).parent()).slideToggle(150);
  });
}
function addEventListenerToShowVideoBtns() {
  if (!document.querySelector('.video-section')) return;
  $('.single-product-video__container').on('click', function (e) {
    $(this).toggleClass('-is-open');
    $('.single-product-video__video', this).slideToggle(150);
  });
}
function addEventListenerToProductAddons() {
  if (!document.querySelector('.product-addons__container')) return;
  $('.product-addons__container').on('click', function (e) {
    $(e.target).parent().toggleClass('-is-open');
    $('.product-addon__content', $(e.target).parent()).slideToggle(150);
  });
}
function addEventListenersToScrollBtns() {
  var scrollToBtns = _toConsumableArray(document.querySelectorAll('#product-button-row .scroll-to-btn'));
  var _iterator = _createForOfIteratorHelper(scrollToBtns),
    _step;
  try {
    var _loop = function _loop() {
      var scrollToBtn = _step.value;
      scrollToBtn.addEventListener('click', function () {
        // Knapparna har dataattribut som bestämmer till vilken div de ska scrolla
        var el = document.getElementById(scrollToBtn.dataset.scrollTo);
        if (!el) return;
        var fromTop = el.getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
          top: fromTop,
          behavior: 'smooth'
        });
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
export function toggleLoadingOverlay() {
  var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (remove) {
    document.getElementById('wl-loading-overlay').remove();
    return;
  }
  var overlay = document.createElement('div');
  overlay.id = 'wl-loading-overlay';
  overlay.innerHTML = '<div class="wl-lds-ring"><div></div><div></div><div></div><div></div></div>';
  document.body.append(overlay);
}
function getChosenVariationIDifSelected(productData) {
  if (!productData.product_variations) return;
  var productVariationsContainer = document.querySelector('.woocommerce-variation-add-to-cart');
  var chosenVariationIdInput = document.querySelector('input[name="variation_id"]');
  if (!productVariationsContainer || !chosenVariationIdInput || chosenVariationIdInput.value === '' || chosenVariationIdInput.value === '0') return;
  var _iterator2 = _createForOfIteratorHelper(product_data.product_variations),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var variation = _step2.value;
      if (variation.variation_id == chosenVariationIdInput.value) {
        return variation.variation_id;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
}

/**
 * Skapar upp en modal med formulär för att skicka in offertförfrågan för en produkt.
 *
 * Kan ta emot bara produktid eller ett objekt innehållande product_id,
 * skapar sen upp en instans av InvoiceModalklassen med svaret från ajaxanropet
 * @param {object[number]} productData
 */
export function getInvoiceModalHtml(productData, type) {
  var _this = this;
  toggleLoadingOverlay();
  console.log(type);
  var productID = productData;
  if (_typeof(productData) === 'object') productID = productData.product_id;
  var maybeVariationID = getChosenVariationIDifSelected(productData);
  if (productData.product_variations && maybeVariationID) productID = maybeVariationID;
  $.ajax({
    url: ajax_handler.ajaxurl,
    data: {
      action: 'get_product_invoice_form',
      product_id: productID
    },
    type: 'GET',
    success: function success(response) {
      toggleLoadingOverlay(true);
      if (!response.success) {
        console.error(response.data);
        addAjaxErrorToElement(_this, response.data);
        return;
      }
      new InvoiceModal('wl-invoice-modal', productID, response.data);
      if (type == 'leasing') {
        $('#leasing-notice-of-interest').prop('checked', true);
      }
    },
    error: function error(err) {
      toggleLoadingOverlay(true);
      console.error(err);
    }
  });
}
function addEventListenerToInvoiceBtn() {
  var invoiceBtn = document.getElementById('request-invoice-btn');
  var leasingBtn = document.getElementById('request-leasing-btn');
  if (!invoiceBtn || typeof product_data === 'undefined' || !product_data.product_id) return;
  invoiceBtn.addEventListener('click', getInvoiceModalHtml.bind(invoiceBtn, product_data, 'invoice'));
  leasingBtn.addEventListener('click', getInvoiceModalHtml.bind(leasingBtn, product_data, 'leasing'));
}
function addAjaxErrorToElement(element, error) {
  // Elementets förälder måste ha position absolute eller relative för att detta ska lira

  // OM det finns ett element så ta bort det innan vi lägger till ett nytt
  if (document.getElementById('wl-error-container')) removeNoticeContainerAndListeners();
  var errorDiv = document.createElement('div');
  errorDiv.id = 'wl-error-container';
  errorDiv.innerHTML = "<div class=\"error-container-error\">\n                            ".concat(error, "\n                        </div>\n                        <button class=\"wl-notice-close-btn\">\n                          x\n                        </button>");
  errorDiv.querySelector('.wl-notice-close-btn').addEventListener('click', removeNotice);
  element.append(errorDiv);
}
function removeNoticeContainerAndListeners() {
  var errorContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.getElementById('wl-error-container');
  if (!errorContainer) return;
  errorContainer.querySelector('.wl-notice-close-btn').removeEventListener('click', removeNotice);
  errorContainer.remove();
}
function removeNotice(e) {
  e.preventDefault();
  e.stopPropagation();
  removeNoticeContainerAndListeners();
}
function createSliderForThumbnails() {
  var galleryParent = document.getElementById('wl-product-gallery');
  if (gallerySliderIsInitiated || !galleryParent || !galleryParent.querySelector('ol li') || galleryParent.querySelector('ol li').length <= 4) return;

  // Vi ersätter thumbnails med ett klonat element som inte har events som kommer från woocommerce på sig
  var originalThumbnailsList = galleryParent.querySelector('ol');
  if (!originalThumbnailsList) return;
  var clonedThumbnails = originalThumbnailsList.cloneNode(true);
  var originalThumbnailsListArr = _toConsumableArray(galleryParent.querySelectorAll('ol li img'));
  originalThumbnailsList.classList.add('-is-hidden');
  galleryParent.append(clonedThumbnails);
  initSlicksliderForClonedThumbnails();
  addClickEventToClonedThumbnailsList(originalThumbnailsListArr, clonedThumbnails);
  gallerySliderIsInitiated = true;
}
function initSlicksliderForClonedThumbnails() {
  $('#wl-product-gallery > ol').slick({
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: '<div class="wl-slider-button slider-next"><img src="' + page_urls.site_uri + '/img/down-arrow-white.svg" alt="slider nästa" /></div>',
    prevArrow: '<div class="wl-slider-button slider-prev"><img src="' + page_urls.site_uri + '/img/down-arrow-white.svg" alt="slider föregående" /></div>'
  });
}
function addClickEventToClonedThumbnailsList(originalThumbnailsListArr, clonedThumbnails) {
  clonedThumbnails.querySelector('.slick-track').addEventListener('click', function (e) {
    // e.target är alltid img-elementet som ligger inlindat i <li>'n
    var currentLi = e.target.parentElement;

    // Trigga klick på ursprungliga thumbnail som har rätt events för att visa rätt stor produktbild.
    // Måste modda skiten också eftersom slick slider bygger extra element.
    if (originalThumbnailsListArr[currentLi.dataset.slickIndex % originalThumbnailsListArr.length]) {
      originalThumbnailsListArr[currentLi.dataset.slickIndex % originalThumbnailsListArr.length].click();
    }
  });
}
function initSlicksliderForLiveImages() {
  var numberOfImagesInContainer = document.querySelectorAll('.live-images__container img').length;
  $('.live-images__container').slick({
    centerMode: true,
    centerPadding: numberOfImagesInContainer >= 4 ? '30px' : 0,
    slidesToShow: numberOfImagesInContainer >= 3 ? 3 : numberOfImagesInContainer,
    infinite: true,
    arrows: true,
    nextArrow: '<div class="wl-slider-button horizontal slider-next"><img src="' + page_urls.site_uri + '/img/down-arrow-white.svg" alt="slider nästa" /></div>',
    prevArrow: '<div class="wl-slider-button horizontal slider-prev"><img src="' + page_urls.site_uri + '/img/down-arrow-white.svg" alt="slider föregående" /></div>',
    responsive: [{
      breakpoint: 1080,
      settings: {
        // centerMode: true,
        centerPadding: numberOfImagesInContainer >= 3 ? '20px' : 0,
        slidesToShow: numberOfImagesInContainer >= 2 ? 2 : numberOfImagesInContainer
      }
    }, {
      breakpoint: 480,
      settings: {
        // arrows: false,
        // centerMode: true,
        // centerPadding: '20px',
        slidesToShow: 1
      }
    }]
  });
}